export const REMOVE_EXTRACTION_INSTRUCTION = "REMOVE_EXTRACTION_INSTRUCTION";
export const SET_IS_LOADING = "SET_IS_LOADING";
export const SET_EXTRACTION_INSTRUCTION = "SET_EXTRACTION_INSTRUCTION";
